// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modalContent {
  background: white;
  width: 800px;
  height: 260px;
  position: relative;
  padding: 10px 20px 40px 20px;
}

.descriptionModal.modalContent {
  box-sizing: border-box;
  max-width: calc(100vw - 40px);
  height: auto;
  max-height: calc(100vh - 40px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.descriptionModal.modalContent .rolagemModal {
  flex: 1 1 auto;
  min-height: 0;
  height: auto;
  max-height: none;
  overflow-x: hidden;
  overflow-y: auto;
}

.descriptionModal.modalContent .modalSubtitle,
.descriptionModal.modalContent .modalText {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.headerModal {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modalTitle {
  color: #79747e;
}

h4.modalSubtitle,
p.modalText {
  font-size: 15px;
  padding: 0px 35px 10px 35px;
}

p.modalTitle {
  font-size: 17px;
  color: #79747e;
}

.closeModal img {
  margin-top: 3px;
  width: 25px;
  cursor: pointer;
  position: absolute;
}

.rolagemModal {
  height: 200px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-engenheiro/modalLog/modalLog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n.modalContent {\n  background: white;\n  width: 800px;\n  height: 260px;\n  position: relative;\n  padding: 10px 20px 40px 20px;\n}\n\n.descriptionModal.modalContent {\n  box-sizing: border-box;\n  max-width: calc(100vw - 40px);\n  height: auto;\n  max-height: calc(100vh - 40px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.descriptionModal.modalContent .rolagemModal {\n  flex: 1 1 auto;\n  min-height: 0;\n  height: auto;\n  max-height: none;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.descriptionModal.modalContent .modalSubtitle,\n.descriptionModal.modalContent .modalText {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.headerModal {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.modalTitle {\n  color: #79747e;\n}\n\nh4.modalSubtitle,\np.modalText {\n  font-size: 15px;\n  padding: 0px 35px 10px 35px;\n}\n\np.modalTitle {\n  font-size: 17px;\n  color: #79747e;\n}\n\n.closeModal img {\n  margin-top: 3px;\n  width: 25px;\n  cursor: pointer;\n  position: absolute;\n}\n\n.rolagemModal {\n  height: 200px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
